import { render } from "./ViewMoodboard.vue?vue&type=template&id=5710e7ff&scoped=true"
import script from "./ViewMoodboard.vue?vue&type=script&lang=js"
export * from "./ViewMoodboard.vue?vue&type=script&lang=js"

import "./ViewMoodboard.vue?vue&type=style&index=0&id=5710e7ff&lang=scss&scoped=true"
import "./ViewMoodboard.vue?vue&type=style&index=1&id=5710e7ff&lang=css"
import "./ViewMoodboard.vue?vue&type=style&index=2&id=5710e7ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5710e7ff"]])

export default __exports__